import { WithModal } from "../Modal"
import { Button } from "../atoms/Buttons"
import React, { useCallback } from "react"
import PropTypes from "prop-types"
import { css } from "styled-components"
import { H2 } from "../atoms/Headings"
import { Margin } from "styled-components-spacing"

export const AddToKarbonAdminNoticeModal = props => {
  const toggle = useCallback(
    show => (
      <Button className={"addButton"} onClick={() => show()}>
        Add to Karbon
      </Button>
    ),
    []
  )

  const modalContent = useCallback(({ hideModal }) => {
    return (
      <div
        css={css`
          text-align: center;
        `}
      >
        <H2 mt={0} centered>
          Talk to Your Admin
        </H2>
        <div
          css={css`
            font-size: 16px;
          `}
        >
          Admin permissions are required to add templates to Karbon. Please
          contact your Karbon administrator about adding this template to your
          account.
        </div>
        <Margin top={4} bottom={1}>
          <Button size={2} onClick={hideModal} upperCase>
            Continue browsing
          </Button>
        </Margin>
      </div>
    )
  }, [])

  return (
    <WithModal
      toggle={props.toggle || toggle}
      ChildContent={modalContent}
      startOpen={props.startOpen}
    />
  )
}

AddToKarbonAdminNoticeModal.propTypes = {
  toggle: PropTypes.func, // Optional custom toggle function, see default one above for signature
}
